const doc = [({"en":({"models":({"feedback_survey":({"new":"New", "started":"Started"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;